import { Box, Stack, TableCell, TableRow, Typography } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { useParams } from "react-router"
import { uniqueId } from "library/database/split-id"
import { navigateGroup } from "../utilities/project-navigation"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { GroupStatusBadge } from "../components/group-status-badge"
import Iconify from "minimals-template/components/Iconify"
import { GroupFailedIcon } from "../components/group-failed-icon"
import { If } from "lib/@components/switch"
import { GroupStatus } from "../../../lib/enum/group-status.js"
import { GroupType } from "../../../lib/enum/group-type.js"
import { Bound } from "lib/@components/binding/Bound"
import { getGroupTypeLabel } from "../../../lib/get-group-type-label"

export function GroupRow({ group }) {
    const { projectId } = useParams()
    const {
        id: groupId,
        name,
        type,
        scheduleId,
        similarTasks,
        addTypeSchedules,
        introTypeSchedules,
        leadingSummaryTypeSchedules,
        status,
    } = group
    const introSchedules = introTypeSchedules?.map((item) => uniqueId(item.id)) ?? []
    const scheduleCount = getScheduleCount()

    return (
        <Bound group={group}>
            <TableRow
                onClick={() => navigateGroup({ projectId, groupId })}
                sx={{ cursor: "pointer" }}
                hover
                data-cy="group-item"
            >
                <TableCell sx={{ whiteSpace: "noWrap", maxWidth: { xs: 150 }, minWidth: { md: 450 } }}>
                    <TruncatedTypography>{name}</TruncatedTypography>
                </TableCell>
                <TableCell data-cy="group-item-schedules" align="right">
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-end"}>
                        <Box display={"flex"} alignItems={"center"}>
                            <Iconify icon={"quill:paper"} sx={{ width: "24px", height: "24px", marginRight: "3px" }} />
                            <Typography minWidth={"10px"}>{scheduleCount}</Typography>
                        </Box>
                        <If truthy={status === GroupStatus.FAILED}>
                            <GroupFailedIcon group={group} />
                        </If>
                    </Stack>
                </TableCell>
                <TableCell sx={{ whiteSpace: "noWrap" }}>{getGroupTypeLabel(type)}</TableCell>
                <TableCell sx={{ whiteSpace: "noWrap" }}>
                    <GroupStatusBadge status={group.status} />
                </TableCell>
                <TableCell data-cy="group-item-menu">
                    <ContextMenuBar type="group" />
                </TableCell>
            </TableRow>
        </Bound>
    )

    function getScheduleCount() {
        if (type === GroupType.OVERWRITE) {
            const overwriteSchedules = [
                uniqueId(scheduleId),
                ...(similarTasks?.map((item) => uniqueId(item.scheduleId)) ?? []),
            ].filter(Boolean)
            return countUniqueSchedules(overwriteSchedules)
        }
        if (type === GroupType.LEADING_SUMMARY) {
            return countUniqueSchedules(leadingSummaryTypeSchedules?.map((item) => uniqueId(item.id)) ?? [])
        }
        if (type === GroupType.INTRODUCTION) {
            return countUniqueSchedules(introSchedules)
        }
        return countUniqueSchedules(addTypeSchedules?.map((item) => uniqueId(item.id)) ?? [])
    }

    function countUniqueSchedules(scheduleIds) {
        const unique = new Set()
        scheduleIds?.forEach((id) => unique.add(id))
        return unique.size ?? 0
    }
}
